<template>
    <div :id="id" :style="'height: ' + height "></div>
</template>
<script>
    import {Rastreador} from "../../../class";
    import '../../../class/leaflet.polylineDecorator';
    import { PosicaoIcone } from "../../../class/posicao-icone";

    export default {
        name: 'MapPosicao',

        props: {
            posicao: {
                default: null
            },
            height: {
                default: '200px'
            }
        },

        data () {
            return {
                marker: null,
                map: null,
                id: "map" +  Math.random(),
                lastLatLong: null
            }
        },

        watch: {
            posicao: function (newQuestion, oldQuestion) {
                if (this.map && newQuestion) {
                    this.marker
                        .setLatLng([newQuestion.lat, newQuestion.long])
                        .setIcon(PosicaoIcone.createIcon(newQuestion))
                        .setTooltipContent(this.getPlaca(newQuestion.placa, newQuestion.ignition))
                        .update();

                    this.map.setView([newQuestion.lat, newQuestion.long]);
                    this._newLine(newQuestion.lat, newQuestion.long);
                    this.lastLatLong = [newQuestion.lat, newQuestion.long];
                }
            }
        },

        mounted() {
            setTimeout(() => this.maps(), 100);
        },

        beforeDestroy () {
            this.map  = null;
        },

        methods: {
            getLasts () {

                Rastreador.lasts(this.posicao.id_rastreador).then ((data) => {
                    data.forEach((d) => {

                        if (this.lastLatLong) {
                            this._newLine(d.lat, d.long);
                        }

                        this.lastLatLong = [d.lat, d.long];

                    })
                })
                .catch(err => console.error(err));
            },

            getPlaca(placa, ign){
                return (ign === 'ON') ? "<span style='color:GREEN'><b>" + placa + "</b><span>" : "<span style='color:GRAY'><b>" + placa + "</b><span>";
            },

            _newLine (lat, lng) {
                let latlngs = [
                    this.lastLatLong,
                    [lat, lng]
                ];

                let markerLine = L.polyline(latlngs, { color: 'red' }).addTo(this.map);

                L.polylineDecorator(markerLine, {
                    patterns: [
                        {
                            offset: 25, repeat: 50,

                            symbol: L.Symbol.arrowHead({
                                pixelSize: 15, pathOptions: {
                                    fillOpacity: 1,  color: 'red', weight: 0
                                }
                            })

                        }
                    ]
                }).addTo(this.map);


            },

            maps () {
                let option = {
                    fullscreenControl: true,
                };

                this.map = L.map(this.id, option).setView([this.posicao.lat, this.posicao.long], 13);

                // this.map.addControl(new L.Control.Fullscreen());




                /*
                let layerGoogle = L.tileLayer(
                    'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
                    attribution: '&copy; OpenStreetMap contributors'
                });


                const layerGoogle = L.tileLayer('https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
                    attribution: '© Google',
                    maxZoom: 20
                });
                 */


                let layerGoogle = L.tileLayer('https://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga', {
                    attribution: '&copy; OpenStreetMap contributors'
                });

                let layerSateliteGoogle = L.tileLayer(
                    'https://mt0.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
                    attribution: '&copy; OpenStreetMap contributors'
                });

                let layerOSM = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; OpenStreetMap contributors'
                });

                /*
                let layerCartografico = L.tileLayer('https://mt0.google.com/vt/lyrs=r&hl=en&x={x}&y={y}&z={z}', {
                    attribution: '&copy; OpenStreetMap contributors'
                });

                let layerTerreno = L.tileLayer('https://mt0.google.com/vt/lyrs=p&hl=en&x={x}&y={y}&z={z}', {
                    attribution: '&copy; OpenStreetMap contributors'
                });

                 */

                layerOSM.addTo(this.map);

                let baseMaps = {
                    ' &nbsp;OpenStreetMaps': layerOSM,
                    " &nbsp;Sat&eacute;lite": layerSateliteGoogle,
                    " &nbsp;Sat&eacute;lite Hibrido": layerGoogle,
                    //" &nbsp;Cartogr&aacute;fico": layerCartografico,
                    //" &nbsp;Terreno": layerTerreno
                };

                L.control.layers(baseMaps).addTo(this.map);

                /*
                this.marker = L.marker([this.posicao.lat, this.posicao.long])
                    .bindTooltip(this.posicao.placa,
                    {
                        permanent: true,
                        offset: [-16,-16],
                        className: 'class-tooltip',
                        direction: 'top'
                    }).addTo(this.map);*/

                this.marker = L.marker([this.posicao.lat, this.posicao.long], {
                    icon: PosicaoIcone.createIcon(this.posicao)
                })
                    .bindTooltip(this.getPlaca(this.posicao.placa, this.posicao.ignition), {
                        permanent: true,
                        offset: [1,-45],
                        className: 'class-tooltip',
                        direction: 'top'
                    })
                    .addTo(this.map).openTooltip();

                this.map.invalidateSize();

                setTimeout (() => this.getLasts(), 1000);
            },
        },


    }
</script>
<style >
    /* tooltip-class*/

    .leaflet-tooltip.class-tooltip {
        /* background: green; */
        text-transform: uppercase;
        font-size: 10px;
        padding: 0;
        padding-right: 1px;
        padding-left: 1px;
        /* border: 2px solid cyan */
    }

    .leaflet-tooltip-left.class-tooltip::before {
        /* border-left-color: cyan; */
    }

    .leaflet-tooltip-right.class-tooltip::before {
        /* border-right-color: cyan; */
    }
</style>
